import { isRouteErrorResponse, useRouteError } from 'react-router';
import { BotaoLink, Pagina, Vazio } from '../ui';

/** Erro de rota: página inexistente ou exceção numa tela (não derruba o app inteiro). */
export function PaginaErro() {
  const erro = useRouteError();
  const naoAchou = isRouteErrorResponse(erro) && erro.status === 404;
  if (!naoAchou) console.error(erro);

  return (
    <Pagina titulo={naoAchou ? 'Página não encontrada' : 'Algo deu errado'}>
      <Vazio
        titulo={naoAchou ? 'Este endereço não existe.' : 'Recarregue a página e tente de novo.'}
      >
        <BotaoLink to="/pedidos" variante="secundario">
          Voltar para os pedidos
        </BotaoLink>
      </Vazio>
    </Pagina>
  );
}
